import React from 'react';
import { useNavigate } from 'react-router-dom';

function MeksanalizPage() {
  const navigate = useNavigate();

  const analizler = [
    { baslik: "Günlük Piyasa Analizi", tarih: "15 Ocak 2025", kategori: "Genel" },
    { baslik: "BIST 100 Teknik Analiz", tarih: "14 Ocak 2025", kategori: "Teknik" },
    { baslik: "Haftalık Strateji Raporu", tarih: "13 Ocak 2025", kategori: "Strateji" }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">MeksaAnaliz</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto py-12 px-4">
        <div className="bg-gradient-to-br from-[#1e5a8e] to-[#26c6da] rounded-lg shadow-lg p-12 text-white mb-8">
          <h2 className="text-4xl font-bold mb-4">Piyasa Analizleri</h2>
          <p className="text-xl opacity-90">Uzman ekibimizden güncel piyasa analizleri ve raporlar</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="text-4xl mb-3">📈</div>
            <h3 className="text-xl font-bold text-[#1e5a8e] mb-2">Teknik Analiz</h3>
            <p className="text-gray-600">Grafik analizi ve teknik göstergeler</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="text-4xl mb-3">📊</div>
            <h3 className="text-xl font-bold text-[#1e5a8e] mb-2">Temel Analiz</h3>
            <p className="text-gray-600">Finansal tablolar ve değerleme</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="text-4xl mb-3">📰</div>
            <h3 className="text-xl font-bold text-[#1e5a8e] mb-2">Piyasa Gündem</h3>
            <p className="text-gray-600">Güncel piyasa haberleri</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-[#1e5a8e] mb-6">Son Analizler</h3>
          <div className="space-y-4">
            {analizler.map((analiz, index) => (
              <div key={index} className="border-b pb-4 hover:bg-gray-50 p-4 rounded cursor-pointer transition-colors">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-bold text-gray-800 mb-1">{analiz.baslik}</h4>
                    <p className="text-sm text-gray-500">{analiz.tarih}</p>
                  </div>
                  <span className="px-3 py-1 bg-[#26c6da] bg-opacity-20 text-[#1e5a8e] rounded-full text-sm font-semibold">
                    {analiz.kategori}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MeksanalizPage;
